// @flow
import client from '../../client'

// API Endpoints
export const RESEND_BOOKING_EMAIL_URL = '/resend-confirmation-email/'

/**
 * Resend confirmation to given email address.
 * @param  {Object} data User account information.
 * @param  {string} data.email The user's email address.
 * @return {Promise|Error} A resolved Promise with the boolean response whether the password
 *                           reset was successful or Rejected with an Error
 */
export const resendConfirmationEmail = (data: {
  email: string,
}): Promise<any> => {
  const options = {
    body: { ...data },
  }

  return client.post(RESEND_BOOKING_EMAIL_URL, options)
}

export default resendConfirmationEmail
